// Vendors
import { Theme as EQStheme } from '@equisoft/design-elements-react';

// Src
import { ThemeColors } from './themeSettings';

export interface IThemeInfo {
    designElements: EQStheme;
    colors: ThemeColors;
}
export interface IDesignSystem {
    theme: EQStheme;
}
export interface IThemeKeySets {
    [themeKey: string]: IThemeInfo;
}

export const DSThemeCore = (colors: ThemeColors): EQStheme => {
    return {
        main: {
            'primary-1.1': colors.primaryColor,
            'primary-1.2': colors.primaryColorLight,
            'primary-1.3': colors.primaryColorDark,
            'primary-2': colors.primaryColor2,
            'primary-3': colors.primaryColor3,
            'secondary-4.1': colors.secondaryColor,
            'secondary-4.2': colors.secondaryColorLight,
            'secondary-4.3': colors.secondaryColorDark,
        },
        greys: {
            white: '#FFFFFF',
            'colored-white': '#F8F9FA',
            'light-grey': '#F1F2F2',
            grey: '#D9DDE2',
            'mid-grey': '#9CA7B4',
            'dark-grey': '#60666E',
            black: '#000000',
        },
        notifications: {
            'info-1.1': '',
            'success-1.1': '#008F37',
            'success-1.2': '#E5F7E9',
            'success-1.3': '#7FC98C',
            'alert-2.1': '#CD2C23',
            'alert-2.2': '#FFCDD2',
            'warning-3.1': '#FF6F00',
            'warning-3.2': '#FFECB3',
            'warning-3.3': '#FFB302',
            'warning-3.4': '',
        },
        tokens: {
            'focus-box-shadow': '0 0 0 2px #0080A566',
            'focus-border-box-shadow': '0 0 0 3px #0080A566, 0 0 0 1px #0080A5',
            'focus-border-box-shadow-inset': 'inset 0 0 0 3px #0080A566, inset 0 0 0 1px #0080A5',
            'focus-border': '#0080A5',
            'modal-overlay-background-color': ' rgba(0, 0, 0, 0.75)',
            'overlay-box-shadow': 'none',
        },
    };
};
